import { Vector2 } from "@react-three/fiber";

export default function angleBetweenPoints(in1: Vector2, in2: Vector2) {
  return Math.atan2(in2.y - in1.y, in2.x - in1.x);
}
